<span class="description-text">
  @if (parts(); as p) {
    <span>{{ p.before }}</span
    ><span class="highlighted-id" [class.highlighted-mismatch]="isWarning()">{{ p.id }}</span
    ><span>{{ p.after }}</span>
  } @else {
    {{ description() }}
  }
</span>
@if (performanceDescription(); as perfDesc) {
  <mat-icon class="performance-info-icon" [matTooltip]="perfDesc" matTooltipPosition="above"
    >info</mat-icon
  >
}
